// extracted by mini-css-extract-plugin
module.exports = {"header_row":"Header_header_row__3d2Ft","description":"Header_description__2p6py"};